import { OverlayService } from './../../../services/overlay.service';
import { Publication } from './../../../interfaces/publication';
import { Subscription } from 'rxjs';
import { PublicationService } from './../../../services/publication.service';
import { ClipboardService } from 'ngx-clipboard';
import { SapiEntity } from './../../../services/sapi.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
	selector: 'bb-embed-bar',
	templateUrl: './bb-embed-bar.component.html',
	styleUrls: ['./bb-embed-bar.component.scss']
})

export class BbEmbedBarComponent implements OnInit, OnDestroy {
	@Input() embedPath: string;
	@Input() extraPreviewParameters = '';
	@Input() entity: SapiEntity;
	@Input() idProp = 'id';
	baseurl = '';
	embedcode = '';

	subscriptions = new Subscription();

	constructor(
		private clipboardService: ClipboardService,
		private publicationService: PublicationService,
		private overlayService: OverlayService
	) {

	}

	ngOnInit() {
		this.subscriptions.add(this.publicationService.getData().subscribe((pub: Publication) => {
			if (pub) {
				this.baseurl = this.publicationService.baseUrl;
			}
		}));
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	getBaseLink() {
		if (!this.entity) {
			return '';
		}
		const id = this.entity[this.idProp];
		if (!id) {
			return '';
		}
		return `https://${this.baseurl}/${this.embedPath}/${id}`;
	}

	getEmbedCode() {
		const id = this.entity && this.entity[this.idProp];
		if (id) {
			this.embedcode = `<script type="text/javascript" src="${this.getBaseLink()}.js"></script>`;
		} else {
			this.embedcode = '';
		}
		return this.embedcode;
	}

	getPreviewLink() {
		if (!this.entity) {
			return '';
		}
		return `${this.getBaseLink()}.html${this.extraPreviewParameters}`;
	}

	copyEmbedCodeToClipboard(str: string) {
		this.clipboardService.copyFromContent(str);
		this.overlayService.createToast('Copied to clipboard', 'clipboard');
	}
}
